import { SUBJECT_ID } from 'constants/index'
import moment from 'moment'
import 'moment-timezone'

export const bookingHelper = {
  getEvaluationList,
  calcEndTime,
  checkCanCancelBooking,
  getAllProgramAndLevelTestRatings,
  getTeachingTime,
  getAssigneHours,
}

function getEvaluationList(bookingData) {
  const {
    vocabulary,
    listening,
    use_of_english,
    speaking,
    pronunciation,
    reading_and_writing,
    subject_id,
    student_attitude,
    is_applied_rating_template,
  } = bookingData || {}
  switch (subject_id) {
    case SUBJECT_ID.MATH:
      if (is_applied_rating_template) {
        return [
          {
            label: 'Tác phong - Thái độ',
            ratingValue: student_attitude?.nums_of_star,
            ratingKey: 'student_attitude',
          },
          {
            label: 'Tư duy phản biện và sáng tạo',
            ratingValue: vocabulary,
            ratingKey: 'vocabulary',
          },
          { label: 'Mức độ hiểu bài', ratingValue: use_of_english, ratingKey: 'use_of_english' },
          { label: 'Lập luận và giải thích', ratingValue: listening, ratingKey: 'listening' },
          {
            label: 'Vận dụng kiến thức vào thực tiễn',
            ratingValue: speaking,
            ratingKey: 'speaking',
          },
          { label: 'Kỹ năng tính toán', ratingValue: pronunciation, ratingKey: 'pronunciation' },
          {
            label: 'Reading and Writing',
            ratingValue: reading_and_writing,
            ratingKey: 'reading_and_writing',
            disabled: true,
          },
        ]
      }
      return [
        { label: 'Kỷ luật', ratingValue: vocabulary, ratingKey: 'vocabulary' },
        { label: 'Tinh thần học tập', ratingValue: listening, ratingKey: 'listening' },
        { label: 'Tiếp thu', ratingValue: use_of_english, ratingKey: 'use_of_english' },
        { label: 'Tương tác', ratingValue: speaking, ratingKey: 'speaking' },
        { label: 'Chuyên cần', ratingValue: pronunciation, ratingKey: 'pronunciation' },
        {
          label: 'Reading and Writing',
          ratingValue: reading_and_writing,
          ratingKey: 'reading_and_writing',
          disabled: true,
        },
      ]
    case SUBJECT_ID.ENGLISH:
      if (is_applied_rating_template) {
        return [
          {
            label: 'Classroom Behavior',
            ratingValue: student_attitude?.nums_of_star,
            ratingKey: 'student_attitude',
          },
          { label: 'Vocabulary', ratingValue: vocabulary, ratingKey: 'vocabulary' },
          { label: 'Grammar', ratingValue: use_of_english, ratingKey: 'use_of_english' },
          { label: 'Listening Skills', ratingValue: listening, ratingKey: 'listening' },
          { label: 'Speaking Skills', ratingValue: speaking, ratingKey: 'speaking' },
          { label: 'Reading Skills', ratingValue: pronunciation, ratingKey: 'pronunciation' },
          {
            label: 'Writing Skills',
            ratingValue: reading_and_writing,
            ratingKey: 'reading_and_writing',
          },
        ]
      }
      return [
        { label: 'Vocabulary', ratingValue: vocabulary, ratingKey: 'vocabulary' },
        { label: 'Listening', ratingValue: listening, ratingKey: 'listening' },
        { label: 'Use of English', ratingValue: use_of_english, ratingKey: 'use_of_english' },
        { label: 'Speaking', ratingValue: speaking, ratingKey: 'speaking' },
        { label: 'Pronunciation', ratingValue: pronunciation, ratingKey: 'pronunciation' },
        {
          label: 'Reading and Writing',
          ratingValue: reading_and_writing,
          ratingKey: 'reading_and_writing',
        },
      ]
    case SUBJECT_ID.CHINESE:
      return [
        { label: 'Vocabulary', ratingValue: vocabulary, ratingKey: 'vocabulary' },
        { label: 'Listening Skill', ratingValue: listening, ratingKey: 'listening' },
        { label: 'Sentence Pattern', ratingValue: use_of_english, ratingKey: 'use_of_english' },
        { label: 'Speaking Skill', ratingValue: speaking, ratingKey: 'speaking' },
        { label: 'Reading Skill', ratingValue: pronunciation, ratingKey: 'pronunciation' },
        {
          label: 'Writing Skill',
          ratingValue: reading_and_writing,
          ratingKey: 'reading_and_writing',
        },
        {
          label: 'Learning Attitude',
          ratingValue: student_attitude?.nums_of_star,
          ratingKey: 'student_attitude',
        },
      ]
    default:
      return []
  }
}

function getAllProgramAndLevelTestRatings(placementTestInfo, isProgramMath) {
  const { listening, pronunciation, reading, speaking, vocabulary, writing } = placementTestInfo
  if (isProgramMath) {
    return [
      { label: 'Số - Đại số', ratingValue: vocabulary, ratingKey: 'vocabulary' },
      { label: 'Tư duy, suy luận', ratingValue: listening, ratingKey: 'listening' },
      { label: 'Hình học', ratingValue: writing, ratingKey: 'writing' },
      { label: 'Mô hình hóa', ratingValue: speaking, ratingKey: 'speaking' },
      { label: 'Xác suất và thống kê', ratingValue: pronunciation, ratingKey: 'pronunciation' },
      {
        label: 'Giải quyết vấn đề',
        ratingValue: reading,
        ratingKey: 'reading',
      },
    ]
  }
  return [
    { label: 'Vocabulary', ratingValue: vocabulary, ratingKey: 'vocabulary' },
    { label: 'Listening', ratingValue: listening, ratingKey: 'listening' },
    { label: 'Writing', ratingValue: writing, ratingKey: 'writing' },
    { label: 'Speaking', ratingValue: speaking, ratingKey: 'speaking' },
    { label: 'Pronunciation', ratingValue: pronunciation, ratingKey: 'pronunciation' },
    {
      label: 'Reading',
      ratingValue: reading,
      ratingKey: 'reading',
    },
  ]
}

function calcEndTime(startTime, endTime, duration = 0, formatType = 'X') {
  if (!duration) {
    if (endTime) return moment(endTime * 1000).format(formatType)
    return ''
  }
  if (!startTime) return ''
  return moment(startTime * 1000)
    .add({ seconds: duration })
    .format(formatType)
}

function checkCanCancelBooking(booking) {
  if (!booking) return false
  const { begin_at, end_at, program_teaching_time } = booking || {}
  const now = moment()
  const calcEndAt = calcEndTime(begin_at, end_at, program_teaching_time, 'X')
  const endAt = moment(calcEndAt * 1000)
  return now < endAt
}

function getTeachingTime(duration) {
  // nếu thời gian là 30' thì hiện 25'
  if (duration === 1800) {
    return duration - 5 * 60
  }
  // nếu thời gian là 60' thì hiện 45'
  if (duration === 3600) {
    return duration - 15 * 60
  }
  return duration
}

function getAssigneHours(programModel) {
  switch (programModel) {
    case 9:
      return '7'
    default:
      return '12'
  }
}
